import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router, Route } from '@angular/router';
import {
  AlertService,
  GrowlType,
} from 'app/infrastructure/services/alert.service';
import { Translator } from 'angular-translator';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmacionModalComponent } from 'app/helpers/components/confirmationModal/confirmationModal.component';
import { ProductReportService } from "app/infrastructure/services/productreport.service";
import { ProductReport } from 'app/infrastructure/model/classes/productReport.class';

@Component({
  selector: 'sx-product-report-subscription-list',
  templateUrl: './product.report.subscription.list.component.html',
})
export class ProductReportSubscriptionListComponent implements OnInit {
  organizationCode: string;
  subscriptionCode: string;
  channelCode: string;
  productCode: string;
  documentKind: string;
  preguntarSiDeseaBorrar = [];
  productReports: ProductReport[] = new Array<
  ProductReport
  >();

  constructor(
    private productReportSrv: ProductReportService,
    private router: Router,
    private aRoute: ActivatedRoute,
    private alertService: AlertService,
    private translate: Translator,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {
      this.organizationCode = params['codorganizacion'];
      this.subscriptionCode = params['codsistema'];
      this.channelCode = params['codnegocio'];
      this.productCode = params['codproducto'];
      this.documentKind = params['documentKind'];

      this.productReportSrv
        .getAllSubscribed(
          this.organizationCode,
          this.subscriptionCode,
          this.channelCode,
          this.productCode
        )
        .subscribe((res) => (this.productReports = res));
    });
  }

  clickEdit(productReportId: string) {
    this.router.navigate(['.', productReportId], {
      relativeTo: this.aRoute,
    });
  }

  clickDelete(productReportId: string, name: string) {
    const modalRef = this.modalService.open(ConfirmacionModalComponent);
    const modalInstance = <ConfirmacionModalComponent>(
      modalRef.componentInstance
    );
    const text = <string>this.translate.instant('DISABLE_TEXT');

    modalInstance.titulo = `${text} ${name}?`;
    modalRef.result.then((confirmacion) => {
      this.productReportSrv
        .unsubscribe(
          productReportId,
          this.organizationCode,
          this.subscriptionCode,
          this.channelCode,
          this.productCode
        )
        .then((success) => {
          if (success) {
            this.alertService.showGrowl(
              {
                type: GrowlType.SUCCESS,
                body: 'SUCCESSFUL_DELETE_BUSINESS_LOGIC',
              },
              { name: name }
            );
          } else {
            this.alertService.showGrowl(
              {
                type: GrowlType.DANGER,
                body: 'COULD_NOT_DELETE_BUSINESS_LOGIC',
              },
              { name: name }
            );
          }
          this.productReports = this.productReports.filter(
            (f) => f.id !== productReportId
          );
        });
    });
  }

  isPolicy() {
    return this.documentKind === 'Policy';
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/product/productReport/subscribe/subscribe-list/product.report.subscription.list.component.ts